import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { MenuItem } from "../_helpers/enumerator";
const initialmanagementUserData = {
  //facility information
  ManagementUserID: 0,
  FacilityID: 0,
  UserRoleID: 0,
  // Role: 0,
  FirstName: "",
  MiddleName: "",
  LastName: "",
  Username: "",
  UserPassword: "",
  // Status: 1,
  Email: "",
  Address1: "",
  Address2: "",
  ActiveStatus: 1,
  City: "",
  CreatedBy: 0,
  StateNameID: 0,
  ZIP: "",
  PhoneNumber: "",
  // PDSPermission: 0,
  // AllFormsAccess: 0,
  isPublicDefenderServicesAccess: 0,
  isAllowtoAccessOthersPDForm: 0,

  type_ManagementUserMenuPermission: [
    {
      managementMenuID: 0,
      menuActiveStatus: 0,
      subManagementMenuID: 0,
      subMenuActiveStatus: 0,
    },
  ],
  type_ManagementUserRequestFormPermission: [
    {
      RequestFormTypeID: 0,
      RfPermissionID: 0,
      FacilityID: 0,
      ActiveStatus: 0,
      FormView: 0,
      FormRespond: 0,
    },
  ],
  type_PostalMailAccessibleFacility: [
    {
      mangementUserID: 0,
      facilityID: 0,
      isActive: 0,
    },
  ],
};

//Menu
const menuList = [
  {
    ManagementMenuID: MenuItem.UserMenuItem,
    MenuName: "Management Users",
    MenuActiveStatus: 1,
    isActive: 1,
  },
  {
    ManagementMenuID: MenuItem.DashboardMenuItem,
    MenuName: "Dashboard",
    MenuActiveStatus: 1,
    SubManagementMenuID: 0,
    SubMenuActiveStatus: 0,
    isActive: 1,
  },
  {
    ManagementMenuID: MenuItem.DocumentsMenuItem,
    MenuName: "Documents",
    MenuActiveStatus: 1,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "Upload",
        SubManagementMenuID: 21,
        SubMenuActiveStatus: 1,
        SubMenuId: "DocUpload",
      },
      {
        SubMenuName: "Active",
        SubManagementMenuID: 19,
        SubMenuActiveStatus: 1,
        SubMenuId: "DocActivate",
      },
      {
        SubMenuName: "Inactive",
        SubManagementMenuID: 20,
        SubMenuActiveStatus: 1,
        SubMenuId: "DocDeActivate",
      },
      {
        SubMenuName: "Delete",
        SubManagementMenuID: 18,
        SubMenuActiveStatus: 1,
        SubMenuId: "DocDelete",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.PostalMailMenuItem,
    MenuName: "Postal Mail",
    MenuActiveStatus: 1,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "Upload",
        SubManagementMenuID: 21,
        SubMenuActiveStatus: 1,
        SubMenuId: "PMupload",
      },
      {
        SubMenuName: "Review",
        SubManagementMenuID: 23,
        SubMenuActiveStatus: 1,
        SubMenuId: "PMreveiw",
      },
      {
        SubMenuName: "Legal Mail",
        SubManagementMenuID: 37,
        SubMenuActiveStatus: 0,
        SubMenuId: "PMlegalMail",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.LockdownMenuItem,
    MenuName: "Lockdown",
    MenuActiveStatus: 1,
    isActive: 1,
    SubManagementMenuID: 0,
    SubMenuActiveStatus: 0,
  },
  {
    ManagementMenuID: MenuItem.InmatesMenuItem,
    MenuName: "Inmates",
    isActive: 1,
    MenuActiveStatus: 1,
    subMenu: [
      {
        SubMenuName: "Modify",
        SubManagementMenuID: 17,
        SubMenuActiveStatus: 1,
        SubMenuId: "InmatesModify",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.PublicUsersMenuItem,
    MenuName: "Public Users",
    MenuActiveStatus: 1,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "Modify",
        SubManagementMenuID: 17,
        SubMenuActiveStatus: 1,
        SubMenuId: "PUModify",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.RequestsOrGrievancesMenuItem,
    MenuName: "Staff Request",
    MenuActiveStatus: 1,
    isActive: 1,
    SubManagementMenuID: 0,
    SubMenuActiveStatus: 0,
  },
  {
    ManagementMenuID: MenuItem.MessagesMenuItem,
    MenuName: "Messages",
    MenuActiveStatus: 1,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "View",
        SubManagementMenuID: 22,
        SubMenuActiveStatus: 1,
        SubMenuId: "MessagesView",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.PhotosMenuItem,
    MenuName: "Photos",
    MenuActiveStatus: 1,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "View",
        SubManagementMenuID: 22,
        SubMenuActiveStatus: 1,
        SubMenuId: "PhotosView",
      },
      {
        SubMenuName: "Review",
        SubManagementMenuID: 23,
        SubMenuActiveStatus: 1,
        SubMenuId: "PhotosReView",
      },
    ],
  },

  {
    ManagementMenuID: MenuItem.KeywordsMenuItem,
    MenuName: "Keywords",
    MenuActiveStatus: 1,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "Add",
        SubManagementMenuID: 16,
        SubMenuActiveStatus: 1,
        SubMenuId: "KeywordsAdd",
      },
      {
        SubMenuName: "Modify",
        SubManagementMenuID: 17,
        SubMenuActiveStatus: 1,
        SubMenuId: "KeywordsModify",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.NoticesMenuItem,
    MenuName: "Notices",
    MenuActiveStatus: 1,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "Add",
        SubManagementMenuID: 16,
        SubMenuActiveStatus: 1,
        SubMenuId: "NoticesAdd",
      },
      {
        SubMenuName: "Modify",
        SubManagementMenuID: 17,
        SubMenuActiveStatus: 1,
        SubMenuId: "NoticesModify",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.ConnectionRequests,
    MenuName: "Connection Requests",
    MenuActiveStatus: 0,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "View",
        SubManagementMenuID: 22,
        SubMenuActiveStatus: 0,
        SubMenuId: "CrView",
      },
      {
        SubMenuName: "Review",
        SubManagementMenuID: 23,
        SubMenuActiveStatus: 0,
        SubMenuId: "CrReView",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.Reporting,
    MenuName: "Reporting",
    MenuActiveStatus: 1,
    isActive: 1,
  },
  // {
  //   ManagementMenuID: 4,
  //   MenuName: "RevenueReporting",
  //   MenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: 5,
  //   MenuName: "Pod",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: MenuItem.KiosksMenuItem,
  //   MenuName: "Kisoks",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: 14,
  //   MenuName: "Facility",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },

  // {
  //   ManagementMenuID: 16,
  //   MenuName: "Registered Users",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: 18,
  //   MenuName: "DND Users",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: 19,
  //   MenuName: "Log Reports",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },

  // {
  //   ManagementMenuID: 21,
  //   MenuName: "Maintenance Schedules",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: 22,
  //   MenuName: "Payment Report",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: 23,
  //   MenuName: "IP Activity",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: 24,
  //   MenuName: "Text Search	",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
];

const initialMenu = [
  {
    ManagementMenuID: MenuItem.UserMenuItem,
    MenuName: "Management Users",
    MenuActiveStatus: 1,
    isActive: 1,
  },
  {
    ManagementMenuID: MenuItem.DashboardMenuItem,
    MenuName: "Dashboard",
    MenuActiveStatus: 1,
    SubManagementMenuID: 0,
    SubMenuActiveStatus: 0,
    isActive: 1,
  },
  {
    ManagementMenuID: MenuItem.DocumentsMenuItem,
    MenuName: "Documents",
    MenuActiveStatus: 1,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "Upload",
        SubManagementMenuID: 21,
        SubMenuActiveStatus: 1,
        SubMenuId: "DocUpload",
      },
      {
        SubMenuName: "Active",
        SubManagementMenuID: 19,
        SubMenuActiveStatus: 1,
        SubMenuId: "DocActivate",
      },
      {
        SubMenuName: "Inactive",
        SubManagementMenuID: 20,
        SubMenuActiveStatus: 1,
        SubMenuId: "DocDeActivate",
      },
      {
        SubMenuName: "Delete",
        SubManagementMenuID: 18,
        SubMenuActiveStatus: 1,
        SubMenuId: "DocDelete",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.PostalMailMenuItem,
    MenuName: "Postal Mails",
    MenuActiveStatus: 1,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "Upload",
        SubManagementMenuID: 21,
        SubMenuActiveStatus: 1,
        SubMenuId: "PMupload",
      },
      {
        SubMenuName: "Review",
        SubManagementMenuID: 23,
        SubMenuActiveStatus: 1,
        SubMenuId: "PMreveiw",
      },
      {
        SubMenuName: "Legal Mail",
        SubManagementMenuID: 37,
        SubMenuActiveStatus: 0,
        SubMenuId: "PMlegalMail",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.LockdownMenuItem,
    MenuName: "Lockdown",
    MenuActiveStatus: 1,
    isActive: 1,
    SubManagementMenuID: 0,
    SubMenuActiveStatus: 0,
  },
  {
    ManagementMenuID: MenuItem.InmatesMenuItem,
    MenuName: "Inmates",
    isActive: 1,
    MenuActiveStatus: 1,
    subMenu: [
      {
        SubMenuName: "Modify",
        SubManagementMenuID: 17,
        SubMenuActiveStatus: 1,
        SubMenuId: "InmatesModify",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.PublicUsersMenuItem,
    MenuName: "Public Users",
    MenuActiveStatus: 1,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "Modify",
        SubManagementMenuID: 17,
        SubMenuActiveStatus: 1,
        SubMenuId: "PUModify",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.RequestsOrGrievancesMenuItem,
    MenuName: "Staff Requests",
    MenuActiveStatus: 1,
    isActive: 1,
    SubManagementMenuID: 0,
    SubMenuActiveStatus: 0,
  },
  {
    ManagementMenuID: MenuItem.MessagesMenuItem,
    MenuName: "Messages",
    MenuActiveStatus: 1,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "View",
        SubManagementMenuID: 22,
        SubMenuActiveStatus: 1,
        SubMenuId: "MessagesView",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.PhotosMenuItem,
    MenuName: "Photos",
    MenuActiveStatus: 1,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "View",
        SubManagementMenuID: 22,
        SubMenuActiveStatus: 1,
        SubMenuId: "PhotosView",
      },
      {
        SubMenuName: "Review",
        SubManagementMenuID: 23,
        SubMenuActiveStatus: 1,
        SubMenuId: "PhotosReView",
      },
    ],
  },

  {
    ManagementMenuID: MenuItem.KeywordsMenuItem,
    MenuName: "Keywords",
    MenuActiveStatus: 1,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "Add",
        SubManagementMenuID: 16,
        SubMenuActiveStatus: 1,
        SubMenuId: "KeywordsAdd",
      },
      {
        SubMenuName: "Modify",
        SubManagementMenuID: 17,
        SubMenuActiveStatus: 1,
        SubMenuId: "KeywordsModify",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.NoticesMenuItem,
    MenuName: "Notices",
    MenuActiveStatus: 1,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "Add",
        SubManagementMenuID: 16,
        SubMenuActiveStatus: 1,
        SubMenuId: "NoticesAdd",
      },
      {
        SubMenuName: "Modify",
        SubManagementMenuID: 17,
        SubMenuActiveStatus: 1,
        SubMenuId: "NoticesModify",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.ConnectionRequests,
    MenuName: "Connection Requests",
    MenuActiveStatus: 0,
    isActive: 1,
    subMenu: [
      {
        SubMenuName: "View",
        SubManagementMenuID: 22,
        SubMenuActiveStatus: 0,
        SubMenuId: "CrView",
      },
      {
        SubMenuName: "Review",
        SubManagementMenuID: 23,
        SubMenuActiveStatus: 0,
        SubMenuId: "CrReView",
      },
    ],
  },
  {
    ManagementMenuID: MenuItem.Reporting,
    MenuName: "Reporting",
    MenuActiveStatus: 1,
    isActive: 1,
  },
  // {
  //   ManagementMenuID: 4,
  //   MenuName: "RevenueReporting",
  //   MenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: 5,
  //   MenuName: "Pod",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: MenuItem.KiosksMenuItem,
  //   MenuName: "Kisoks",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: 14,
  //   MenuName: "Facility",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },

  // {
  //   ManagementMenuID: 16,
  //   MenuName: "Registered Users",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: 18,
  //   MenuName: "DND Users",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: 19,
  //   MenuName: "Log Reports",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },

  // {
  //   ManagementMenuID: 21,
  //   MenuName: "Maintenance Schedules",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: 22,
  //   MenuName: "Payment Report",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: 23,
  //   MenuName: "IP Activity",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
  // {
  //   ManagementMenuID: 24,
  //   MenuName: "Text Search	",
  //   MenuActiveStatus: 0,
  //   SubManagementMenuID: 0,
  //   SubMenuActiveStatus: 0,
  //   isActive: 0,
  // },
];

// Management User Search
const managementUserSearch = {
  loggedInUserRoleID: 1,
  facilityID: 0,
  Username: "",
  FullName: "",
  UserRoleID: 0,
  City: "",
  ZIP: "",
  ActiveStatus: 2,
  pageNo: 1,
  rowCountPerPage: 10,
  sortBy: "CreatedDate DESC",
  accessBy: 1,
};

// create slice
const name = "managementUser";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const managementUserAction = { ...slice.actions, ...extraActions };
export const managementUserReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    managementUserData: initialmanagementUserData,
    managementUserSearchData: managementUserSearch,
    menu: menuList,
    Role: [],
    managementUserList: [],
    managementUserFullList: [],
    managementUserInfo: [],
    PostalMailGrid: [],
    UserAccessibleRequestForm: [],
    createUserResponse: null,
    updateUserResponse: null,
    PULoginResponse: null,
    initialMenu: initialMenu,
    iframeUser:[],
  };
}

function createReducers() {
  return {
    setmanagementUserData,
    setRequestForm,
    setPostalMailGrid,
    setManagementUserSearchData,
    updatemenuList,
    resetForm,
    clearManagementUserInfo,
    clearmanagementUserFullList,
    clearmanagementUserData,
    resetManagementUserSearchData,
    resetMenuList,
  };
  function resetForm(state) {
    // Resetting the form fields to their default values
    state.managementUserData = { ...initialmanagementUserData };
  }
  function setmanagementUserData(state, action) {
    state.managementUserData = action.payload && action.payload;
  }
  function clearmanagementUserData(state) {
    state.managementUserData = [];
  }
  function clearManagementUserInfo(state) {
    state.managementUserInfo = [];
  }
  function clearmanagementUserFullList(state) {
    state.managementUserFullList = [];
  }
  function updatemenuList(state, action) {
    state.menu = action && action.payload;
  }
  function resetMenuList(state) {
    state.menu = initialMenu;
  }
  function setPostalMailGrid(state, action) {
    state.PostalMailGrid = action && action.payload;
  }
  function setRequestForm(state, action) {
    state.UserAccessibleRequestForm = action && action.payload;
  }
  function setManagementUserSearchData(state, action) {
    state.managementUserSearchData = action && action.payload;
  }
  function resetManagementUserSearchData(state) {
    state.managementUserSearchData = { ...managementUserSearch };
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/User`;
  // const PULoginUrl = `${process.env.REACT_APP_PUBLIC_USER_SYS_API}`;
  const PULoginUrl = `${process.env.REACT_APP_API_URL}`;
  return {
    GetUserRole: GetUserRole(),
    LoadManagementUserList: LoadManagementUserList(),
    GetManagementUserInfo: GetManagementUserInfo(),
    LoadPostalMailAccessibleFacility: LoadPostalMailAccessibleFacility(),
    LoadUserAccessibleRequestForm: LoadUserAccessibleRequestForm(),
    CreateManagementUser: CreateManagementUser(),
    UpdateManagementUser: UpdateManagementUser(),
    GetPublicLoginValidate: GetPublicLoginValidate(),
  };

  function GetUserRole() {
    return createAsyncThunk(
      `${name}/GetUserRole`,
      async () => await fetchWrapper.get(`${baseUrl}/GetUserRole?UserRoleID=1`)
    );
  }
  function LoadManagementUserList() {
    return createAsyncThunk(
      `${name}/LoadManagementUserList`,
      async (params) =>
        await fetchWrapper.post(`${baseUrl}/LoadManagementUserList`, params)
    );
  }
  function GetManagementUserInfo() {
    return createAsyncThunk(
      `${name}/GetManagementUserInfo`,
      async (Id) =>
        await fetchWrapper.get(
          `${baseUrl}/GetManagementUserInfo?ManagementUserID=${Id}`
        )
    );
  }
  function LoadPostalMailAccessibleFacility() {
    return createAsyncThunk(
      `${name}/LoadPostalMailAccessibleFacility`,
      async ({ ManagementUserID, FacilityID }) =>
        await fetchWrapper.get(
          `${baseUrl}/LoadPostalMailAccessibleFacility?ManagementUserID=${encodeURIComponent(
            ManagementUserID
          )}&FacilityID=${encodeURIComponent(FacilityID)}`
        )
    );
  }
  function LoadUserAccessibleRequestForm() {
    return createAsyncThunk(
      `${name}/LoadUserAccessibleRequestForm`,
      async ({ ManagementUserID, FacilityID }) =>
        await fetchWrapper.get(
          `${baseUrl}/LoadUserAccessibleRequestForm?ManagementUserID=${encodeURIComponent(
            ManagementUserID
          )}&FacilityID=${encodeURIComponent(FacilityID)}`
        )
    );
  }

  function CreateManagementUser() {
    return createAsyncThunk(
      `${name}/CreateManagementUser`,
      async (params) =>
        await fetchWrapper.post(`${baseUrl}/CreateManagementUser`, params)
    );
  }

  function UpdateManagementUser() {
    return createAsyncThunk(
      `${name}/UpdateManagementUser`,
      async (params) =>
        await fetchWrapper.post(`${baseUrl}/UpdateManagementUser`, params)
    );
  }

  function GetPublicLoginValidate() {
    return createAsyncThunk(
      `${name}/GetPublicLoginValidate`,
      async ({ UserName, UserPassword, BrowserType, IPAddres }) =>
        await fetchWrapper.get(
          `${PULoginUrl}/LoginUser/GetPublicLoginValidate?UserName=${UserName}&UserPassword=${UserPassword}&BrowserType=${BrowserType}&IPAddress=${IPAddres}&isSALoginAsPU=${1}`
        )
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.GetUserRole.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetUserRole.fulfilled, (state, action) => {
      state.loading = false;
      state.Role = action.payload;
      state.error = null;
    })
    .addCase(extraActions.GetUserRole.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })
    //Load the Table List
    .addCase(extraActions.LoadManagementUserList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadManagementUserList.fulfilled, (state, action) => {
      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.managementUserFullList = action.payload;
      } else {
        state.managementUserList = action.payload;
      }
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.LoadManagementUserList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })
    //Get the ManagementUserInfo
    .addCase(extraActions.GetManagementUserInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetManagementUserInfo.fulfilled, (state, action) => {
      state.loading = false;
      state.managementUserInfo = action.payload;
      state.error = null;
    })
    .addCase(extraActions.GetManagementUserInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })
    //Load Postal Mail Accessible Facility for bind Grid view
    .addCase(extraActions.LoadPostalMailAccessibleFacility.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadPostalMailAccessibleFacility.fulfilled,
      (state, action) => {
        state.loading = false;
        state.PostalMailGrid = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadPostalMailAccessibleFacility.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }
    )

    //LoadUserAccessibleRequestForm  for bind Grid view
    .addCase(extraActions.LoadUserAccessibleRequestForm.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadUserAccessibleRequestForm.fulfilled,
      (state, action) => {
        state.loading = false;
        state.UserAccessibleRequestForm = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadUserAccessibleRequestForm.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }
    )
    //Create ManagementUser Response
    .addCase(extraActions.CreateManagementUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.CreateManagementUser.fulfilled, (state, action) => {
      state.loading = false;
      state.createUserResponse = action.payload;
      state.error = null;
    })
    .addCase(extraActions.CreateManagementUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })
    //Update ManagementUser Response
    .addCase(extraActions.UpdateManagementUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.UpdateManagementUser.fulfilled, (state, action) => {
      state.loading = false;
      state.updateUserResponse = action.payload;
      state.error = null;
    })
    .addCase(extraActions.UpdateManagementUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })
    // GetPublicLoginValidate
    .addCase(extraActions.GetPublicLoginValidate.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetPublicLoginValidate.fulfilled, (state, action) => {
      state.loading = false;
      state.PULoginResponse = action.payload;
      state.error = null;
      state.iframeUser = action.payload;



      // Set cookies for system test URL
      // ${process.env.REACT_APP_PUBLIC_USER_DOMAIN}
      // document.cookie = `user=${encodeURIComponent(JSON.stringify(user))}; path=/; domain=${process.env.REACT_APP_PUBLIC_USER_DOMAIN};secure; SameSite=None`;
      // document.cookie = `PUPasswordLogID=${encodeURIComponent(user?.PUPasswordLogID)}; path=/; domain=${process.env.REACT_APP_PUBLIC_USER_DOMAIN};secure; SameSite=None`;
    //   document.cookie = `token=${encodeURIComponent(
    //     user.LoginToken
    //   )}; path=/; domain=${
    //     process.env.REACT_APP_PUBLIC_USER_DOMAIN
    //   };secure; SameSite=None`;
    //   document.cookie = `userID=${encodeURIComponent(
    //     user?.PublicUserID
    //   )}; path=/; domain=${
    //     process.env.REACT_APP_PUBLIC_USER_DOMAIN
    //   };secure; SameSite=None`;
    //   document.cookie = `redirectTo=${encodeURIComponent(
    //     user?.RedirectTo
    //   )}; path=/; domain=${
    //     process.env.REACT_APP_PUBLIC_USER_DOMAIN
    //   };secure; SameSite=None`;
     })

    .addCase(extraActions.GetPublicLoginValidate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
}
